import { Fragment, useEffect, useState } from 'react';

function BokunWidget(props) {
	useEffect(() => {
		const iframeHtml = '<script type="text/javascript" src="https://widgets.bokun.io/assets/javascripts/apps/build/BokunWidgetsLoader.js?bookingChannelUUID='+props.bookingChannelUUID+'" async></script>'+
			'<div class="bokunWidget" data-src="https://widgets.bokun.io/online-sales/'+props.onlineSalesPath+'?lang='+props.lang+'"></div>'+
			'<noscript>Please enable javascript in your browser to book</noscript>';

		const iframe = document.getElementById('bokun-widget-iframe');

		iframe.contentWindow.document.open();
		iframe.contentWindow.document.write(iframeHtml);
	}, []);

	return <iframe id="bokun-widget-iframe" width="100%" height={props.frameHeight || 2500} frameBorder={'no'}></iframe>
}

export default BokunWidget;